import { Component, OnInit } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute, ParamMap } from '@angular/router'
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgProgress } from '@ngx-progressbar/core';
import { MatDialog } from "@angular/material";
import { ChangePassComponent } from "./change-pass/change-pass.component";
import { GlobalServiceService } from '../../services/global-service.service'
import { NotificacionesService } from '../notificaciones.service'
import { UsersService } from "../../users/users.service";
import { ApiBasic } from "../../services/api-basic";
import Swal from 'sweetalert2'
import * as moment from "moment";
moment.locale("es");

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  providers: [NgbDropdownConfig]
})
export class NavbarComponent implements OnInit {

  public sidebarOpened = true;
  public isLogged: boolean = false
  private _unsubscribeAll: Subject<any>;
  public userInfo = JSON.parse(localStorage.getItem('userInfo'))
  interval
  toggleOffcanvas() {
    document.querySelector(".addDisplay").classList.toggle("addDisplayNone");
    document
      .querySelector(".addBackground")
      .classList.toggle("addBackgroundColorWidth");

    this.sidebarOpened = !this.sidebarOpened;

    if (this.sidebarOpened) {
      document.querySelector(".sidebar-offcanvas").classList.add("active");
      document.querySelector(".main-panel").classList.add("has-sidemenu");
      document
        .querySelector(".header-backbutton")
        .classList.add("has-sidemenu");
      if (document.querySelector(".maintenancesTable") != null) {
        document
          .querySelector(".maintenancesTable")
          .classList.add("has-sidemenu");
      }
    } else {
      document.querySelector(".sidebar-offcanvas").classList.remove("active");
      document.querySelector(".main-panel").classList.remove("has-sidemenu");
      document
        .querySelector(".header-backbutton")
        .classList.remove("has-sidemenu");
      if (document.querySelector(".maintenancesTable") != null) {
        document
          .querySelector(".maintenancesTable")
          .classList.remove("has-sidemenu");
      }
    }
  }

  numNotifications: Array<any> = []
  notesNotifications: Array<any> = []
  allNotifications: any = ''
  allNotificationsData: any = ''
  reportsNotifications: Array<any>
  maintenanceNotifications: Array<any>
  userData: any
  infoUser: any;
  primer_inicio: any

  private unSubscribe$ = new Subject<void>();

  constructor(
    config: NgbDropdownConfig,
    public app: GlobalServiceService,
    private route: ActivatedRoute,
    private router: Router,
    private _location: Location,
    public notificacionesService: NotificacionesService,
    public progress: NgProgress,
    private dialog: MatDialog,
    public userService: UsersService,
    public apiBasic: ApiBasic
  ) {
    config.placement = 'bottom-right';
    this._unsubscribeAll = new Subject();
  }

  ngOnInit() {
    this.app.logged.pipe(takeUntil(this._unsubscribeAll)).subscribe(value => {
      this.isLogged = value;
    });

    this.app.userInfoData
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(value => {
        if (value != null) {
          this.userData = value;
          this.dataUser();
          this.loadTestNotification()
          // this.viewNumNotifications()

          // if (this.interval != undefined) {
          //   clearInterval(this.interval);
          // }
          // this.interval = setInterval(
          //   this.viewTotalNotifications.bind(this)
          //   1000
          // );
        } else {
          if (this.interval != undefined) {
            clearInterval(this.interval);
          }
        }
      });
    this.allNotifications = 0;

  }

  loadTestNotification() {
    let id = this.userData.usuario_id.toString();
    //Numero total de notificaciones
    this.notificacionesService.getTotalNotificationsFirebaseActivoF(id)
      .pipe(
        takeUntil(this.unSubscribe$)
      ).subscribe((data: any) => {
        this.allNotificationsData = data
        this.allNotifications = data.length
        // const audio = new Audio("../assets/notificacion.mp3");
        // audio.play();
      })
    //Total de anterior
    this.notificacionesService.getTotalNotificationsFirebaseInactivoF(id)
      .pipe(
        takeUntil(this.unSubscribe$)
      ).subscribe(data => {

        this.numNotifications = data
      })
    //Data de mantenimientos
    this.notificacionesService.getMaintenanceActiveF(id)
      .pipe(
        takeUntil(this.unSubscribe$)
      ).subscribe(data => {
        this.maintenanceNotifications = data
      })
    //Data de Reportes
    this.notificacionesService.getReportActiveF(id)
      .pipe(
        takeUntil(this.unSubscribe$)
      ).subscribe(data => {
        this.reportsNotifications = data
      })

    //Data de Notas
    this.notificacionesService.getNotesActiveF(id)
      .pipe(
        takeUntil(this.unSubscribe$)
      ).subscribe(data => {
        this.notesNotifications = data
      })
  }

  dataUser() {
    this.userService
      .getDetailUser(this.userData.id, this.userData.usuario_id)
      .subscribe((res: any) => {
        if (res.success) {
          this.primer_inicio = res.data.primer_inicio_sesion

          this.infoUser = {
            nombre: res.data.nombre,
            email: res.data.email,
            fecha_de_nacimiento: res.data.fecha_de_nacimiento,
            genero: res.data.genero,
            cliente: this.userData.nombre_cliente,
            rol_id: res.data.rol_id,
            plantas_list: res.data.plantas_list,
            //imagen_base64: res.data.imagen,
            fecha_validez: moment(res.data.fecha_validez).format('YYYY-MM-DD'),
            tipo_usuario: res.data.tipo_usuario == 'interno' ? 1 : 2
          };

          if (res.data.tipo_usuario == 'interno') {
            this.infoUser.departamento_id = res.data.departamento_id
            this.infoUser.puesto_id = res.data.puesto_id
          }

          this.infoUser.plantas_list = this.infoUser.plantas_list.map(
            item => {
              return item.planta_id;
            }
          );

        }
      });
  }

  changePass() {
    const dialogConfirm = this.dialog.open(ChangePassComponent, {
      width: "50%",
      disableClose: true,
      data: {
        id: this.userData.id,
        usuario_id: this.userData.usuario_id,
        primer_inicio: this.primer_inicio,
        infoUser: this.infoUser
      }
    });
    /* dialogConfirm.afterClosed().subscribe(res => {
      if (res) {
        this.progress.start()
        this.infoUser.verifypassword = res.pass_old.trim();
        this.infoUser.password = res.pass_new.trim();
        this.userService
          .editUser(this.userData.id, this.userData.usuario_id, this.infoUser)
          .subscribe((resChangePass: any) => {
            if (resChangePass.success) {
              this.progress.complete()
              this.showMsg("Contraseña actualizada correctamente");
            } else {
              this.progress.complete()
              if (resChangePass.msg == "La Contraseña es incorrecta")
                this.showMsg(
                  "Error, verifique que su contraseña anterior sea correcta"
                );
              else this.showMsg(resChangePass.msg);
            }
          });
      }
    }); */
  }

  viewTotalNotifications() {
    if (this.userData != undefined) {
      this.notificacionesService.getTotalNotifications(this.userData.usuario_id).subscribe((resAll: any) => {

        if (this.allNotifications != resAll.data[0].total) {
          this.viewMaintenanceNotifications()
          this.viewReportsNotifications()
          this.viewNotesNotifications()
        }
        this.allNotifications = resAll.data[0].total


      });
      this.viewNumNotifications()
    }

  }

  viewMaintenanceNotifications() {
    this.notificacionesService.getMaintenanceNotifications(this.userData.usuario_id).subscribe((resMaintenance: any) => {
      if (resMaintenance.success) {

        this.maintenanceNotifications = resMaintenance.data

      }
    });
  }

  viewReportsNotifications() {
    this.notificacionesService.getReportsNotifications(this.userData.usuario_id).subscribe((resReports: any) => {
      if (resReports.success) {

        this.reportsNotifications = resReports.data
      }
    });
  }

  viewNotesNotifications() {
    this.notificacionesService.getNotesNotifications(this.userData.usuario_id).subscribe((resNotes: any) => {
      if (resNotes.success) {

        this.notesNotifications = resNotes.data
      }
    })
  }

  viewNumNotifications() {
    let cantidad = 10
    this.notificacionesService.getNumNotifications(this.userData.usuario_id, cantidad).subscribe((resNum: any) => {
      if (resNum.success) {
        // this.numNotifications = resNum.data

      }
    })
  }

  openMaintenance(mant) {

    let id = this.userData.usuario_id.toString();

    if (mant.tipo_notificacion == 10 || mant.tipo_notificacion == 2 || mant.tipo_notificacion == 3 || mant.tipo_notificacion == 16 || mant.tipo_notificacion == 13 || mant.tipo_notificacion == 19 || mant.tipo_notificacion == 20 || mant.tipo_notificacion == 21 || mant.tipo_notificacion == 23 || mant.tipo_notificacion == 24 || mant.tipo_notificacion == 25|| mant.tipo_notificacion == 26) {
      this.notificacionesService.updateStatusF(id, mant.notificacion_id.toString())
      this.router.navigate(['mantenimientos', 'list', mant.detalle.id_maintenance], { queryParams: { 'notification_id': mant.notificacion_id, 't': new Date().getTime() } });

    }
  }

  openReport(report) {
    let id = this.userData.usuario_id.toString();

    if (report.tipo_notificacion == 4 || report.tipo_notificacion == 6 || report.tipo_notificacion == 7 || report.tipo_notificacion == 14 || report.tipo_notificacion == 15 || report.tipo_notificacion == 22) {
      this.notificacionesService.updateStatusF(id, report.notificacion_id.toString())

      this.router.navigate(['reportes', 'list', report.detalle.report_id], { queryParams: { 'notification_id': report.notificacion_id, 't': new Date().getTime() } })

    }

    if (report.tipo_notificacion == 2 || report.tipo_notificacion == 3 || report.tipo_notificacion == 9 || report.tipo_notificacion == 10 || report.tipo_notificacion == 13 ) {

      this.router.navigate(['mantenimientos', 'list', report.detalle.id_maintenance], { queryParams: { 'notification_id': report.notification_id, 't': new Date().getTime() } })

    }

  }

  openNote(note) {
    let id = this.userData.usuario_id.toString();

    if (note.tipo_notificacion == 1) {
      this.notificacionesService.updateStatusF(id, note.notificacion_id.toString())
      this.router.navigate(['mantenimientos', 'list', note.detalle.id_maintenance], { queryParams: { 'notification_id': note.notification_id, 't': new Date().getTime() } })

    }

    if (note.tipo_notificacion == 8) {
      this.notificacionesService.updateStatusF(id, note.notificacion_id.toString())
      this.router.navigate(['reportes', 'list', note.detalle.id_maintenance], { queryParams: { 'notification_id': note.notification_id, 't': new Date().getTime() } })

    }

  }

  openAll() {
    this.router.navigate(['notificaciones'])
  }

  // deactivateAll() {
  //   this.notificacionesService.deleteAllNotifications(this.userData.usuario_id).subscribe((res: any) => {

  //   })
  // }
  deactivateAll() {

    Swal({
      title: '¿Seguro quiere hacer esta acción?',
      text: 'Se marcaran todas las notificaciones como leídas',
      // text: "You won't be able to revert this!",
      // icon: 'warning',
      inputClass: 'warning',

      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {

        this.notificacionesService.updateStatusAllF(this.userData.usuario_id, this.allNotificationsData).then(res=>{
          Swal(
            'Marcadas todas como leídas',
            '',
            'success'
          )
        }).catch(err=>{
          if (this.app.flagLogs) {
          console.warn(err);
          }
          Swal(
            'Error',
            '',
            'warning'
          )
        })

      }
    })



    // this.notificacionesService.updateStatusAllF(this.userData.usuario_id, this.allNotificationsData).then(res=>{

    // }).catch(err=>{
    //   console.warn(err);

    // })
  }
  deactiveNote() {
  }

  deactiveReport() {
  }

  deactiveMant() {
  }

  openNotificacion(notificaciones) {

    if (notificaciones.tipo_notificacion == 4 || notificaciones.tipo_notificacion == 6 || notificaciones.tipo_notificacion == 7 || notificaciones.tipo_notificacion == 14 || notificaciones.tipo_notificacion == 15) {

      this.router.navigate(['reportes', 'list', notificaciones.detalle.report_id])

    }

    if (notificaciones.tipo_notificacion == 8) {

      this.router.navigate(['reportes', 'list', notificaciones.detalle.id_maintenance])

    }

    if (notificaciones.tipo_notificacion == 1 || notificaciones.tipo_notificacion == 2 || notificaciones.tipo_notificacion == 3 || notificaciones.tipo_notificacion == 9 || notificaciones.tipo_notificacion == 10 || notificaciones.tipo_notificacion == 13 || notificaciones.tipo_notificacion == 19 || notificaciones.tipo_notificacion == 21 || notificaciones.tipo_notificacion == 23 || notificaciones.tipo_notificacion == 25 || notificaciones.tipo_notificacion == 26) {

      this.router.navigate(['mantenimientos', 'list', notificaciones.detalle.id_maintenance])

    }

  }

  closeLoading() {

    this.progress.complete()
  }

  logOut() {
    localStorage.removeItem('userInfo')
    localStorage.removeItem('access')
    localStorage.removeItem('userInfoEncrypted')
    // localStorage.removeItem('base_image_url')
    // localStorage.removeItem('base_url')
    // localStorage.removeItem('base_cargas_masivas')

    this.app.setLogged(false)
    this.router.navigate(['login'])
    clearInterval(this.interval)
    this.dialog.closeAll()
  }

  backClicked() {
    this._location.back();
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
    clearInterval(this.interval)
  }

}
